import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core';

const styles = () => ({
  root: {
    display: 'flex',
    alignContent: 'center',
  },
});

function ListItemContent({
  className, classes, expand, alternativeToggleDisplay, children, ...rest
}) {
  return (
    <div
      className={classNames(classes.root, className)}
      {...rest}
    >
      {children}
    </div>
  );
}

ListItemContent.defaultProps = {
  className: '',
  resource: {},
  alternativeToggleDisplay: false,
  expand: false,
};

ListItemContent.propTypes = {
  expand: PropTypes.bool,
  alternativeToggleDisplay: PropTypes.bool,
  resource: PropTypes.object,
  children: PropTypes.any.isRequired,
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(ListItemContent);
